const initializeRazorPay = () => {
  return new Promise((resolve) => {
    const razorPayScript = document.createElement("script");
   // razorPayScript.src = "https://online.manipalcigna.com/checkout.js";
   razorPayScript.src = " https://checkout.razorpay.com/v1/checkout.js";

    razorPayScript.onload = () => {
      resolve(true);
    };
    razorPayScript.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(razorPayScript);
  });
};

const withoutUpiMethods = [
  {
    method: "card",
  },
  {
    method: "paylater",
  },
  {
    method: "emi",
  },
  {
    method: "wallet",
  },
  {
    method: "netbanking",
  }
]
export const makePayment = async ({
  quoteId = "",
  totalAmount,
  isUpiAsba,
  customerId,
  orderId,
  currency = "INR",
  name,
  policyNum,
  mobileNumber,
  emailId,
  razorpay_key,
  pancard,
  firstName,
  lastName
}) => {
  const razorPayInitiateResponse = await initializeRazorPay();
  // razorpay_key = razorpay_key || process.env.RAZORPAY_KEY
  if (!razorPayInitiateResponse) {
    alert("Something went wrong with Razorpay payment!");
    return;
  }
  return new Promise((resolve, reject) => {
    const options = {
      name: "ManipalCigna Health Insurance",
      // key: razorpay_key,
      currency: currency,
      ...(isUpiAsba ? {customer_id: customerId, recurring: 1} : {}),
      amount: totalAmount.toString(),
      order_id: orderId,
      description: `Payment for renewal of policy number ${policyNum}`,
      image: "/quick-pay/logo.png",
      config: {
        display: {
          // blocks: {
          //   hdfc: { //name for HDFC block
          //     name: "Pay using HDFC Bank",
          //     instruments: [
          //       {
          //         method: "card",
          //         issuers: ["HDFC"]
          //       },
          //       {
          //         method: "netbanking",
          //         banks: ["HDFC"]
          //       },
          //     ]
          //   },
          //   other: { //  name for other block
          //     name: "Other Payment modes",
          //     instruments: [
          //       {
          //         method: "card",
          //         issuers: ["ICIC"]
          //       },
          //       {
          //         method: 'netbanking',
          //       }
          //     ]
          //   }
          // },
          ...(isUpiAsba ? {hide : withoutUpiMethods} : {})
          // hide: [
          //   {
          //     method: "paylater",
          //   },
          //   {
          //     method: "emi",
          //   },
          //   {
          //     method: "cardless_emi",
          //   },
          // ],
          // sequence: ["block.hdfc", "block.other"],
          // preferences: {
          //   show_default_blocks: false // Should Checkout show its default blocks?
          // }
        },
      },
      handler: function (response) {
        resolve({
          transactionId: response.razorpay_payment_id,
          orderId: response.razorpay_order_id,
          paymentSignature: response.razorpay_signature,
          paymentStatus: "Success",
          successMessage: "Payment Successful",
          quoteId: quoteId,
          policyNum: policyNum,
          productId: "",
          paymentType: "",
          panNumber:pancard,
          lastName:lastName,
          firstName:firstName
        });
        return {
          transactionId: response.razorpay_payment_id,
          orderId: response.razorpay_order_id,
          paymentSignature: response.razorpay_signature,
          paymentStatus: "Success",
          successMessage: "Payment Successful",
          quoteId: quoteId,
          policyNum: policyNum,
          productId: "",
          paymentType: "",
          panNumber:pancard,
          lastName:lastName,
          firstName:firstName
        };
      },
      prefill: {
        name: name,
        email: emailId,
        contact: mobileNumber,
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.on("payment.failed", function (response) {
      //alert("Payment has been failed!!");
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
      hideRazorPayContainer();
      reject({
        paymentStatus: "failed",
        successMessage: response?.error?.description,
      });
    });
    paymentObject.open();
  });
};

export const hideRazorPayContainer = () => {
  document.querySelectorAll(".razorpay-container").forEach(function (el) {
    el.style.display = "none";
  });
  document.body.style.overflow = "auto";
};
